import {
  Navbar,
  NavbarBrand,
  Link,
  NavbarMenuToggle,
  NavbarContent,
  NavbarMenuItem,
  NavbarMenu,
} from "@nextui-org/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Logo from "../../components/Logo";
import { useState } from "react";
import "./index.css";

const MOBILE_NAV_CLASSNAMES = {
  wrapper: "site-container !max-w-site",
  brand: "mobile-nav-brand",
  content:
    "gap-0 px-0 data-[justify=start]:flex-grow-0 data-[justify=start]:basis-auto data-[justify=end]:flex-grow data-[justify=end]:basis-0",
  menu: "mobile-nav-menu bg-white px-6 pb-8 pt-0 dark:bg-neutral-950",
  menuItem: "mobile-nav-menu__item",
};

const menuItems = [
  { label: "About", path: "/about" },
  { label: "Work", path: "/work" },
  { label: "Blog", path: "/blog" },
];

function MobileNavbar() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  const isActive = (path: string) => {
    if (path === "/blog") {
      return location.pathname.startsWith("/blog");
    }

    return location.pathname === path;
  };

  return (
    <Navbar
      isBordered
      maxWidth="full"
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      classNames={MOBILE_NAV_CLASSNAMES}
      className="laptop:hidden navbar bg-white dark:bg-neutral-950"
    >
      <NavbarContent justify="start">
        <NavbarBrand>
          <Link as={RouterLink} to="/" className="p-0" onClick={closeMenu}>
            <Logo></Logo>
          </Link>
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent justify="end">
        <NavbarMenuToggle
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        />
      </NavbarContent>

      <NavbarMenu>
        {menuItems.map((item) => (
          <NavbarMenuItem key={item.path} isActive={isActive(item.path)}>
            <RouterLink
              to={item.path}
              onClick={closeMenu}
              className={`mobile-nav-menu__link ${
                isActive(item.path) ? "mobile-nav-menu__link--active" : ""
              }`}
            >
              {item.label}
            </RouterLink>
          </NavbarMenuItem>
        ))}
      </NavbarMenu>
    </Navbar>
  );
}

export default MobileNavbar;
